// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UjT9","index":"styles_index__jRftZ"};